export const settings_names = {
    width: "The width",
    height: "The height",
    top: "The top value",
    left: "The left value",
    text_size: "The font size",
    text_newsticker_speed: "The newsticker speed",
    text_newsticker_margin: "The newsticker margin",
    drop_shadow: "The drop shadow",
    transparency: "The transparency",
    delay: "The delay",
    volume: "The volume",
    refresh: "The refresh",
    page_from: "The value for \"From page\"",
    page_to: "The value for \"To page\"",
    duration: "The duration",
    transition_length: "The transition length",
    loops: "The value for loops"
}

export const settings_invalid = {
    width: "The width is invalid.",
    height: "The height is invalid.",
    top: "The top value is invalid.",
    left: "The left value is invalid.",
    page_from: "The value for \"From page\" is invalid.",
    page_to: "The value for \"To page\" is invalid.",
    color: "The color is invalid.",
    duration: "The duration is invalid.",
    transition_length: "The transition length is invalid.",
    loop: "The value for loops is invalid.",
    primary_color: "The value for the main color is invalid.",
    secondary_color: "The value for the secondary color is invalid."
}

export const settings_empty = {
    width: "No width specified.",
    height: "No height specified.",
    top: "No top value specified.",
    left: "No left value specified.",
    color: "No color specified.",
    duration: "No duration specified.",
    loop: "No value for loops specified.",
    display_runs: "No duration specified."
}
